<!--
+-------------------------------------------+
| blaze-action-bar                          |
|-------------------------------------------|
| content                                   |
|   * fit-window                            |
|                                           |
|                                           |
|                                           |
+-------------------------------------------+
-->
<main>
  <div class="blaze-app">
    @if (user() && (displayActionBar$ | async)) {
      <blaze-action-bar />
    }

    <div class="mt-8 grow" [class]="routerContainerClass$ | async">
      <router-outlet />
    </div>
  </div>
</main>
